import React from 'react';
import { DarkenAvatar } from '../DarkenAvatar';

const UserAvatar = ({ firstname, lastname, ...other }) => (
  <DarkenAvatar {...other}>
    {firstname?.substr(0, 1).toUpperCase() +
      lastname?.substr(0, 1).toUpperCase()}
  </DarkenAvatar>
);

export default UserAvatar;
